import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import AntalyasBeachesWaterfalls from "../assets/img/Blogs/Turkey/AntalyasBeachesWaterfalls.jpg";
import EphesusRuins from "../assets/img/Blogs/Turkey/EphesusRuins.jpg";
import HagiaSophia from "../assets/img/Blogs/Turkey/HagiaSophia.jpg";
import HotAirBalloonsOverCappadocia from "../assets/img/Blogs/Turkey/HotAirBalloonsOverCappadocia.jpg";
import PamukkalesNaturalPools from "../assets/img/Blogs/Turkey/PamukkalesNaturalPools.jpg";

const Turkey = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap turkeyBlogBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Turkey’s Top 5 Must-Visit Places</h2>
                  <p>
                    Turkey, a land where East meets West, boasts a rich history,
                    stunning landscapes, and vibrant culture. From ancient
                    cities to breathtaking coastlines, here are the top five
                    must-visit destinations in Turkey:
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={HagiaSophia} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2>Istanbul – A City of Two Continents</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A city where East meets West, rich in history and
                      architecture.
                    </p>
                  </div>
                  <p>
                    Istanbul is a fascinating blend of European and Asian
                    influences. The Hagia Sophia, once a church, then a mosque,
                    and now a museum, is an architectural marvel. The Blue
                    Mosque, with its iconic domes and minarets, is a must-visit.
                    Stroll through the Grand Bazaar, one of the world’s oldest
                    markets, filled with spices, textiles, and souvenirs.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Hagia Sophia</p>
                    </li>
                    <li>
                      <p>Blue Mosque</p>
                    </li>
                    <li>
                      <p>Grand Bazaar</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img
                    src={HotAirBalloonsOverCappadocia}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Cappadocia – A Surreal Wonderland</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A magical region with surreal rock formations and cave
                      hotels.
                    </p>
                  </div>
                  <p>
                    Cappadocia’s otherworldly landscape, dotted with fairy
                    chimneys and cave dwellings, makes it one of Turkey’s most
                    unique destinations. A sunrise hot air balloon ride over the
                    region offers breathtaking views. Visitors can also explore
                    ancient cave churches and underground cities carved into the
                    soft volcanic rock.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Hot Air Balloon Rides</p>
                    </li>
                    <li>
                      <p>Fairy Chimneys</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img
                    src={PamukkalesNaturalPools}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Pamukkale – The Cotton Castle</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Famous for white travertine terraces and ancient Roman
                      ruins.
                    </p>
                  </div>
                  <p>
                    Pamukkale, meaning "Cotton Castle" in Turkish, is famous for
                    its white mineral-rich terraces formed by thermal springs.
                    The warm, healing waters are perfect for a relaxing soak.
                    Nearby, the ancient city of Hierapolis features
                    well-preserved Roman ruins, including a grand amphitheater
                    and necropolis.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Thermal Pools</p>
                    </li>
                    <li>
                      <p>Hierapolis Ruins</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img
                    src={AntalyasBeachesWaterfalls}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> Antalya – The Jewel of the Turkish Riviera</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A coastal city with turquoise waters and charming old
                      streets
                    </p>
                  </div>
                  <p>
                    Antalya, located on Turkey’s Mediterranean coast, offers a
                    perfect mix of history and natural beauty. Relax on the
                    stunning beaches, explore the charming old town (Kaleiçi)
                    with its cobblestone streets and Ottoman houses, and visit
                    Düden Waterfalls for a scenic escape. Antalya’s nightlife
                    and local cuisine make it a traveler’s paradise.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Konyaalti Beach</p>
                    </li>
                    <li>
                      <p> Old Town (Kaleiçi)</p>
                    </li>
                    <li>
                      <p>Düden Waterfalls</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={EphesusRuins} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2>Ephesus – An Ancient Marvel</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      One of the best-preserved ancient cities in the world.
                    </p>
                  </div>
                  <p>
                    Ephesus was once a thriving Roman city and remains one of
                    Turkey’s most impressive archaeological sites. Walk through
                    its ancient streets to see the Library of Celsus, an
                    architectural masterpiece, and the remains of the Temple of
                    Artemis, one of the Seven Wonders of the Ancient World.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p> Library of Celsus</p>
                    </li>
                    <li>
                      <p>Temple of Artemis</p>
                    </li>
                    <li>
                      <p>Ancient Ruins</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="finalThouthWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Final Thoughts</h2>
                <p>
                  Turkey’s rich history, diverse landscapes, and warm
                  hospitality make it an unforgettable travel destination.
                  Whether you’re exploring the bustling streets of Istanbul,
                  soaring over Cappadocia in a balloon, or relaxing in the
                  thermal waters of Pamukkale, there’s something for every
                  traveler.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img
                      src={AntalyasBeachesWaterfalls}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="dataWrap">
                    <h2>Start planning your Turkish adventure today!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Turkey;
